import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Modal from 'flarum/common/components/Modal';
import CityPicker from './CityPicker';

export default class DefaultSettingsModal extends Modal {
  oninit(vnode) {
    super.oninit(vnode);

    this.timezones = [];
    this.loading = false;

    this.timezone = '';
    this.city = '';
    this.cityCountry = 'CN';
    this.cityProvince = 'CN-BJ';
    this.cityCityName = '北京市';

    this.loadFromUser();
  }

  className() {
    return 'TaroDefaultSettingsModal Modal--medium';
  }

  title() {
    return '默认便捷设置';
  }

  loadFromUser() {
    const user = app.session.user;
    if (!user) return;
    const prefs = user.preferences ? user.preferences() : {};
    if (prefs.taroDefaultTimezone) {
      this.timezone = prefs.taroDefaultTimezone;
    } else {
      this.timezone = 'Asia/Shanghai';
    }
    if (prefs.taroDefaultCity) {
      const parts = String(prefs.taroDefaultCity).split('|');
      if (parts.length === 3) {
        this.cityCountry = parts[0];
        this.cityProvince = parts[1];
        this.cityCityName = parts[2];
      }
    }
  }

  loadTimezones() {
    if (this.timezones.length > 0) return;
    this.loading = true;
    m.redraw();
    app
      .request({
        method: 'GET',
        url: app.forum.attribute('apiUrl') + '/taro/case/cities/timezones',
      })
      .then((r) => {
        this.timezones = r.timezones || [];
        this.loading = false;
        m.redraw();
      })
      .catch(() => {
        this.loading = false;
        m.redraw();
      });
  }

  content() {
    return (
      <div className="TaroDefaultSettings">
        <p style="color:#666;font-size:13px;">
          设置默认值后，每次发布案例时，抽牌时间和城市将自动使用这些设置。
        </p>

        <div className="Form-group">
          <label>默认时区</label>
          <select
            className="FormControl"
            value={this.timezone}
            onchange={(e) => (this.timezone = e.target.value)}
            onfocus={() => this.loadTimezones()}
          >
            <option value="Asia/Shanghai">东八区 (UTC+8) 北京/上海/香港</option>
            <option value="Asia/Tokyo">东九区 (UTC+9) 东京</option>
            <option value="Asia/Seoul">东九区 (UTC+9) 首尔</option>
            <option value="Asia/Singapore">东八区 (UTC+8) 新加坡</option>
            <option value="Asia/Taipei">东八区 (UTC+8) 台北</option>
            <option value="Europe/London">零时区 (UTC+0) 伦敦</option>
            <option value="Europe/Paris">东一区 (UTC+1) 巴黎</option>
            <option value="America/New_York">西五区 (UTC-5) 纽约</option>
            <option value="America/Los_Angeles">西八区 (UTC-8) 洛杉矶</option>
            <option value="Australia/Sydney">东十区 (UTC+10) 悉尼</option>
            <option value="UTC">协调世界时 (UTC+0)</option>
            {this.timezones.map((tz) => (
              <option value={tz.id}>
                {tz.name || tz.id}
              </option>
            ))}
          </select>
        </div>

        <div className="Form-group">
          <label>默认抽牌城市</label>
          <CityPicker
            country={this.cityCountry}
            province={this.cityProvince}
            city={this.cityCityName}
            onChange={(c, p, ci) => {
              this.cityCountry = c;
              this.cityProvince = p;
              this.cityCityName = ci;
            }}
          />
        </div>

        <div className="Form-group" style="margin-top:15px;">
          <Button
            className="Button Button--primary"
            onclick={() => this.save()}
          >
            保存设置
          </Button>
          <Button
            className="Button"
            onclick={() => app.modal.close()}
          >
            取消
          </Button>
        </div>
      </div>
    );
  }

  save() {
    const user = app.session.user;
    if (!user) return;

    const prefs = {
      ...(user.preferences ? user.preferences() : {}),
    };
    prefs.taroDefaultTimezone = this.timezone;
    prefs.taroDefaultCity = `${this.cityCountry}|${this.cityProvince}|${this.cityCityName}`;

    user
      .save({ preferences: prefs })
      .then(() => {
        app.modal.close();
        app.alerts.show({ type: 'success' }, '默认设置已保存');
      })
      .catch((err) => {
        app.alerts.show({ type: 'error' }, '保存失败：' + (err.statusText || err.responseText || '错误'));
      });
  }
}
